import { SET_LANGUAGE } from './actions'

import { en } from './language-files/en'
import { nl } from './language-files/nl'
import { LanguageActionType, LanguageStore, SupportedLanguages } from './types'

const initialState: LanguageStore = {
  language: SupportedLanguages.EN,
  availableLanguages: [
    {
      code: SupportedLanguages.EN,
      name: 'English',
    },
    {
      code: SupportedLanguages.NL,
      name: 'Nederlands',
    },
  ],
  strings: en,
  isFetching: false,
}

export const reducer = (state = initialState, action: LanguageActionType): LanguageStore => {
  switch (action.type) {
    case SET_LANGUAGE:
      switch (action.language) {
        case SupportedLanguages.NL:
          return {
            ...state,
            strings: nl,
            language: SupportedLanguages.NL,
          }
        case SupportedLanguages.EN:
          return {
            ...state,
            strings: en,
            language: SupportedLanguages.EN,
          }
        default:
          return state
      }

    default:
      return state
  }
}
